// extracted by mini-css-extract-plugin
export default {"container":"Xv-z","heading":"Yv-z","text":"Zv-z","info":"_v-z","link":"aw-z","fullMaxWidth":"bw-z"};